/* eslint-disable */
<template>
  <v-layout justify-center>
    <v-flex xs10 class="mt-5">
      <full-calendar ref="calendar" :events="events" @event-created="eventCreated" :config="config"></full-calendar>
    </v-flex>
    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      class="add-button-bottom"
      height="30"
      @click.stop="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog persistent v-model="viewDialog" max-width="400px">
      <v-card>
        <v-toolbar color="indigo" dark>
          <span class="headline">{{selected.title}}</span>
          <v-btn
            color="blue"
            dark
            small
            absolute
            bottom
            right
            fab
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <span class="body-2">{{formatedStartDate}}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="closeView">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.title"
                  label="Event Title"
                  style="font-size: 1.8em"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-checkbox label="All Day" v-model="editedItem.allDay"></v-checkbox>
              </v-flex>
              <v-flex class="hidden-xs-only" sm6 md8>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="formatedStartDate"
                    label="Start Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="startDate"
                    no-title
                    @input="menu1 = false"
                    :max=this.endDate
                    @change="formatedStartDate = formatDate(startDate)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                  v-if="!editedItem.allDay"
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu3"
                  :nudge-right="40"
                  :return-value.sync="startTime"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="formatedStartTime"
                    label="Start Time"
                    prepend-icon="access_time"
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    v-if="menu3"
                    v-model="startTime"
                    full-width
                    @change="formatedStartTime = makeStartTime(startTime)"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="formatedEndDate"
                    label="End Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="endDate"
                    no-title
                    @input="menu2 = false"
                    :min=this.startDate
                    @change="formatedEndDate = formatDate(endDate)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                  v-if="!editedItem.allDay"
                  ref="menua"
                  :close-on-content-click="false"
                  v-model="menu4"
                  :nudge-right="40"
                  :return-value.sync="endTime"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="formatedEndTime"
                    label="End Time"
                    prepend-icon="access_time"
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    v-if="menu4"
                    v-model="endTime"
                    full-width
                    :min=applyStartTime
                    @change="formatedEndTime = makeEndTime(endTime)"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" :disabled='!editedItem.title' @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import axios from 'axios'
import Utilities from '../services/Utilities'
import { FullCalendar } from 'vue-full-calendar'
// import { RRule, RRuleSet } from 'rrule'
import { RRule } from 'rrule'
import 'fullcalendar/dist/fullcalendar.css'

import moment from 'moment'

export default {
  components: {
    FullCalendar
  },
  data () {
    return {
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
      formatedStartDate: '',
      formatedStartTime: '',
      formatedEndDate: '',
      formatedEndTime: '',
      dialog: false,
      viewDialog: false,
      editedIndex: -1,
      events: [],
      config: {
        googleCalendarApiKey: 'AIzaSyDKmXIzjsMzI5PAgQMumGw6LdEWuxBhiRs',
        timeFormat: 'h:mm a',
        lazyFetching: true,
        eventClick: (event) => {
          this.eventSelected(event)
        },
        header: {
          left: window.innerWidth < 765 ? '' : 'prev,next today',
          center: window.innerWidth < 765 ? 'prev,next today,agendaDay,listMonth' : 'title',
          right: window.innerWidth < 765 ? '' : 'month,agendaWeek,agendaDay,listMonth'
        },
        defaultView: window.innerWidth < 765 ? 'listWeek' : 'month',
        contentHeight: 0,
        businessHours: {
          dow: [ 1, 2, 3, 4, 5 ],

          start: '9:00',
          end: '17:00'
        }
      },
      holiday: {
        id: 0,
        title: '',
        start: '',
        end: '',
        allDay: true,
        description: '',
        userId: 0,
        color: ''
      },
      editedItem: {
        id: 0,
        title: '',
        start: '',
        end: '',
        allDay: false,
        description: '',
        userId: 0,
        color: ''
      },
      defaultItem: {
        id: 0,
        title: '',
        start: '',
        end: '',
        allDay: false,
        description: '',
        userId: 0,
        color: ''
      },
      selected: {}
    }
  },

  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getEvents()
    this.getHolidays()
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Event' : 'Edit Event'
    },

    applyStartTime () {
      if (this.startDate === this.endDate) {
        return this.startTime
      }
    }
  },

  methods: {
    async getEvents () {
      try {
        let response = await Api().get('get_events')

        const events = response.data

        for (let i = 0; i < events.length; i++) {
          if (events[i].rrule) {
            let startcalc = events[i].start.split('T')
            let endcalc = events[i].end.split('T')
            let startdate = moment(startcalc[0])
            let enddate = moment(endcalc[0])

            let days = enddate.diff(startdate, 'days')

            let rrule = events[i].rrule
            rrule = rrule.replace('~', '\n')

            // let rule = RRule.fromString(rrule)
            // let rule = RRule.fromText('every month on the 1st Monday until 07/04/2019')
            let rule = RRule.fromText('every 2 weeks on TU until 07/04/2019')

            let rulea = rule.all()

            for (let j = 0; j < rulea.length; j++) {
              let newEvent = {}
              let start = moment(rulea[j]).format('YYYY-MM-DD') + 'T' + startcalc[1]
              let end = moment(rulea[j]).add(days, 'days').format('YYYY-MM-DD') + 'T' + endcalc[1]

              newEvent.id = events[i].id
              newEvent.title = events[i].title + '(Reoccuring)'
              newEvent.start = start
              newEvent.end = end
              newEvent.allDay = events[i].allDay
              newEvent.description = events[i].description
              newEvent.userId = events[i].userId
              newEvent.color = events[i].color
              newEvent.rrule = events[i].rrule

              this.events.push(newEvent)
            }
          } else {
            this.events.push(events[i])
          }
        }
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getHolidays () {
      try {
        await axios.get('https://www.googleapis.com/calendar/v3/calendars/en.usa%23holiday%40group.v.calendar.google.com/events?key=AIzaSyDKmXIzjsMzI5PAgQMumGw6LdEWuxBhiRs')
          .then(res => {
            const holidays = res.data.items

            for (let i = 0; i < holidays.length; i++) {
              const holiday = {}

              holiday.title = holidays[i].summary
              holiday.start = holidays[i].start.date
              holiday.end = holidays[i].end.date
              holiday.allDay = 1
              holiday.description = holidays[i].summary
              holiday.userId = 0
              holiday.color = 'gray'

              this.events.push(holiday)
            }
          })
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 280
      this.config.contentHeight = height
    },

    refreshEvents () {
      this.$refs.calendar.$emit('refetch-events')
    },

    removeEvent () {
      this.$refs.calendar.$emit('remove-event', this.selected)
      this.selected = {}
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    makeStartTime (time) {
      this.$refs.menu.save(this.startTime)

      return Utilities.displayTime(time)
    },

    makeEndTime (time) {
      this.$refs.menua.save(this.endTime)

      return Utilities.displayTime(time)
    },

    eventSelected (event) {
      this.selected = event

      if (this.selected.allDay) {
        this.formatedStartDate = moment(this.selected.start).format('ddd, MMM Do') + ' - All Day'
      } else {
        this.formatedStartDate = moment(this.selected.start).format('ddd, MMM Do h:mm A - ') +
          moment(this.selected.end).format('ddd, MMM Do h:mm A')
      }

      this.viewDialog = true
      console.log('edit', this.selected)
    },

    eventCreated (...test) {
      console.log('new', test)
      const event = test[0]

      this.editedItem.allDay = true
      this.startDate = moment(event.start).format('YYYY-MM-DD')
      this.endDate = moment(event.end).format('YYYY-MM-DD')
      this.formatedStartDate = moment(event.start).format('MM/DD/YYYY')
      this.formatedEndDate = moment(event.end).format('MM/DD/YYYY')

      this.dialog = true
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.startTime = ''
        this.startDate = ''
        this.endDate = ''
        this.endTime = ''
        this.formatedStartDate = ''
        this.formatedStartTime = ''
        this.formatedEndDate = ''
        this.formatedEndTime = ''
      }, 300)
    },

    closeView () {
      this.viewDialog = false
      setTimeout(() => {
        this.selected = {}
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.startTime = ''
        this.startDate = ''
        this.endDate = ''
        this.endTime = ''
        this.formatedStartDate = ''
        this.formatedStartTime = ''
        this.formatedEndDate = ''
        this.formatedEndTime = ''
      }, 300)
    },

    save () {
      const rule = new RRule({
        freq: RRule.WEEKLY,
        interval: 5,
        byweekday: [RRule.MO, RRule.FR],
        dtstart: new Date(Date.UTC(2012, 1, 1, 10, 30)),
        until: new Date(Date.UTC(2012, 12, 31))
      })

      console.log(rule.toString())

      let startTime = 'T' + this.startTime + ':00'
      let endTime = 'T' + this.endTime + ':00'

      if (!this.startTime) { this.editedItem.allDay = true }

      if (this.editedItem.allDay) {
        startTime = ''
        endTime = ''
      }

      if (!this.endDate) {
        this.endDate = this.startDate
      }

      this.editedItem.start = this.startDate + startTime

      if (!this.endTime && !this.editedItem.allDay) {
        this.editedItem.end = moment(this.editedItem.start).add(1, 'hour').format('YYYY-MM-DDTHH:mm:00')
      } else {
        this.editedItem.end = this.endDate + endTime
      }

      console.log(this.editedIndex)
      if (this.editedIndex > -1) {
        console.log('edit')
        // Object.assign(this.rows[this.editedIndex], this.editedItem)
      } else {
        console.log('save')
        this.events.push(this.editedItem)
      }
      console.log('editedItem', this.editedItem)
      console.log(this.events)
      this.close()
    }

  }
  // computed: {
  //   eventSources () {
  //     const self = this
  //     return [
  //       {
  //         events (start, end, timezone, callback) {
  //           setTimeout(() => {
  //             callback(self.events.filter(() => Math.random() > 0.5))
  //           }, 1000)
  //         }
  //       }
  //     ]
  //   }
  // }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Calendar.vue